﻿/* ================================================================
   EF MANTEL CONFIGURATOR — LOGIC
   ================================================================ */
(function() {
  'use strict';

  /* â”€â”€ Data â”€â”€ */
  var DATA = {
    lengthRanges: [
      { label: '20" – 30"', min: 20, max: 30, surcharge: 0 },
      { label: '31" – 50"', min: 31, max: 50, surcharge: 135 },
      { label: '51" – 70"', min: 51, max: 70, surcharge: 325 },
      { label: '71" – 89"', min: 71, max: 89, surcharge: 725 },
      { label: '90" – 105"', min: 90, max: 105, surcharge: 1350 },
      { label: '106" – 115"', min: 106, max: 115, surcharge: 1550 },
      { label: '116" – 125"', min: 116, max: 125, surcharge: 1750 },
      { label: '126" – 144"', min: 126, max: 144, surcharge: 2225 }
    ],
    /* Variant ID lookup: length inch -> variantId (from Avis option-sets CSV) */
    lengthVariants: {
      "31":"41149810835538","32":"41149810868306","33":"41149810901074","34":"41149810933842",
      "35":"41149810966610","36":"41149810999378","37":"41149811032146","38":"41149811064914",
      "39":"41149811097682","40":"41149811130450","41":"41149811163218","42":"41149811195986",
      "43":"41149811228754","44":"41149811261522","45":"41149811294290","46":"41149811327058",
      "47":"41149811359826","48":"41149811392594","49":"41149811425362","50":"41149811458130",
      "51":"41149811490898","52":"41149811523666","53":"41149811556434","54":"41149811589202",
      "55":"41149811621970","56":"41149811654738","57":"41149811687506","58":"41149811720274",
      "59":"41149811753042","60":"41149811785810","61":"41149811818578","62":"41149811851346",
      "63":"41149811884114","64":"41149811916882","65":"41149811949650","66":"41149811982418",
      "67":"41149812015186","68":"41149812047954","69":"41149812080722","70":"41149812113490",
      "71":"41149812146258","72":"41149812179026","73":"41149812211794","74":"41149812244562",
      "75":"41149812277330","76":"41149812310098","77":"41149812342866","78":"41149812375634",
      "79":"41149812408402","80":"41149812441170","81":"41149812473938","82":"41149812506706",
      "83":"41149812539474","84":"41149812572242","85":"41149812605010","86":"41149812637778",
      "87":"41149812670546","88":"41149812703314","89":"41149812736082","90":"41149812768850",
      "91":"41149812801618","92":"41149812834386","93":"41149812867154","94":"41149812899922",
      "95":"41149812932690","96":"41149812965458","97":"41149812998226","98":"41149813030994",
      "99":"41149813063762","100":"41149813096530","101":"41149813129298","102":"41149813162066",
      "103":"41149813194834","104":"41149813227602","105":"41149813260370","106":"41149813293138",
      "107":"41149813325906","108":"41149813358674","109":"41149813391442","110":"41149813424210",
      "111":"41149813456978","112":"41149813489746","113":"41149813522514","114":"41149813555282",
      "115":"41149813588050","116":"41149813620818","117":"41149813653586","118":"41149813686354",
      "119":"41149813719122","120":"41149813751890","121":"41149813784658","122":"41149813817426",
      "123":"41149813850194","124":"41149813882962","125":"41149813915730","126":"41959765049426",
      "127":"41959765082194","128":"41959765114962","129":"41959765147730","130":"41959765180498",
      "131":"42244809850962","132":"42244809883730","133":"42244809916498","134":"42244809949266",
      "135":"42244809982034","136":"42244810014802","137":"42244810047570","138":"42244810080338",
      "139":"42244810113106","140":"42244810145874","141":"42244810178642","142":"42244810211410",
      "143":"42244810244178","144":"42244810276946"
    },
    heights: [
      { label: '2"', surcharge: 0 },
      { label: '3"', surcharge: 0 },
      { label: '4"', surcharge: 0 },
      { label: '5"', surcharge: 0 },
      { label: '6"', surcharge: 150, variantId: '42244810342482' },
      { label: '7"', surcharge: 200, variantId: '42244810375250' },
      { label: '8"', surcharge: 360, variantId: '42244810408018' },
      { label: '9"', surcharge: 480, variantId: '42244810440786' },
      { label: '10"', surcharge: 620, variantId: '42244810473554' },
      { label: '11"', surcharge: 720, variantId: '42385727848530' },
      { label: '12"', surcharge: 860, variantId: '42385727979602' }
    ],
    depths: [
      { label: '4"', surcharge: 0 },
      { label: '6"', surcharge: 0 },
      { label: '8"', surcharge: 0 },
      { label: '10"', surcharge: 0 },
      { label: '12"', surcharge: 0 },
      { label: '14"', surcharge: 200, variantId: '42244810539090' },
      { label: '16"', surcharge: 400, variantId: '42244810571858' }
    ],
    colors: [
      /* Base */
      { name: 'Matte Black', hex: '#1C1C1C', surcharge: 0, tier: 'Standard', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-matte-black-500.jpg?v=1778032283', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-mota76p8.png?v=1778025039'  },
      { name: 'Textured Black', hex: '#2A2A2A', surcharge: 0, tier: 'Standard', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-textured-black-500.jpg?v=1778032286', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motabjbg.png?v=1778025242'  },
      { name: 'Aspire Rust', hex: '#8B4513', surcharge: 0, tier: 'Standard', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-aspire-rust-500.jpg?v=1778032289', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-mot9zob1.png?v=1778024688'  },
      { name: 'Bronzed Iron', hex: '#6B4C3B', surcharge: 0, tier: 'Standard', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-bronzed-iron-500.jpg?v=1778032293', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-mota0p1h.png?v=1778024736'  },
      { name: 'Charcoal', hex: '#444440', surcharge: 0, tier: 'Standard', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-charcoal-500.jpg?v=1778032295', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-mota3wt6.png?v=1778024886'  },
      { name: 'Copper Vein', hex: '#7D5642', surcharge: 0, tier: 'Standard', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-copper-vein-500.jpg?v=1778032298', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-mota5eh0.png?v=1778024956'  },
      { name: 'Silver Vein', hex: '#9E9E96', surcharge: 0, tier: 'Standard', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-silver-vein-500.jpg?v=1778032304', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-mota9y57.png?v=1778025168'  },
      { name: 'Vintage Vein', hex: '#6E6354', surcharge: 0, tier: 'Standard', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-vintage-vein-500.jpg?v=1778032308', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motad61t.png?v=1778025318'  },
      { name: 'White', hex: '#F5F2ED', surcharge: 0, tier: 'Standard', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-white-500.jpg?v=1778032311', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motaevkr.png?v=1778025397'  },
      /* Premium $315 — with Avis variant IDs */
      { name: 'Antique Black', hex: '#2C2824', surcharge: 315, tier: 'Premium', variantId: '42244810637394', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-antique-black-500.jpg?v=1778032314', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motagejr.png?v=1778025469'  },
      { name: 'Antique Steel', hex: '#636360', surcharge: 315, tier: 'Premium', variantId: '42244810965074', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-antique-steel-500.jpg?v=1778032321', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motahjtr.png?v=1778025524'  },
      { name: 'Brushed Beige', hex: '#C4B39A', surcharge: 315, tier: 'Premium', variantId: '42244810866770', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-brushed-beige-500.jpg?v=1778032323', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motal3wb.png?v=1778025689'  },
      { name: 'Brushed Black', hex: '#232323', surcharge: 315, tier: 'Premium', variantId: '42244810735698', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-brushed-black-500.jpg?v=1778032326', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motan9ly.png?v=1778025789'  },
      { name: 'Brushed Grey', hex: '#8A8680', surcharge: 315, tier: 'Premium', variantId: '42244810997842', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-brushed-grey-500.jpg?v=1778032329', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motaj5v9.png?v=1778025597'  },
      { name: 'Brushed White', hex: '#EDE9E1', surcharge: 315, tier: 'Premium', variantId: '42244810768466', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-brushed-white-500.jpg?v=1778032333', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motaoxz1.png?v=1778025867'  },
      { name: 'Burnished Bronze', hex: '#5A4430', surcharge: 315, tier: 'Premium', variantId: '42244810801234', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-burnished-bronze-500.jpg?v=1778032336', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/burnished-bronze-800.jpg?v=1778042554'  },
      { name: 'Burnished Copper', hex: '#8B5E3C', surcharge: 315, tier: 'Premium', variantId: '42244810834002', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-burnished-copper-500.jpg?v=1778032339', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/burnished-copper-800.jpg?v=1778042557'  },
      { name: 'Champagne', hex: '#D4C5A9', surcharge: 0, tier: 'Standard', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-champagne-500.jpg?v=1778032342', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-mota2al5.png?v=1778024810'  },
      { name: 'Industrial Black', hex: '#1E1E1E', surcharge: 315, tier: 'Premium', variantId: '42244810932306', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-industrial-black-500.jpg?v=1778032352', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motaxfhi.png?v=1778026263'  },
      { name: 'Burnished Latte', hex: '#A89279', surcharge: 315, tier: 'Premium', variantId: '42244811030610', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-metallic-latte-500.jpg?v=1778032355', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/burnished-latte-800.jpg?v=1778042561'  },
      { name: 'Natural Iron', hex: '#4E4B46', surcharge: 315, tier: 'Premium', variantId: '42244811063378', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-natural-iron-500.jpg?v=1778032358', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motaze54.png?v=1778026355'  },
      { name: 'Oil Rubbed Bronze', hex: '#4A3728', surcharge: 0, tier: 'Standard', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-oil-rubbed-bronze-500.jpg?v=1778032361', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-mota8dp9.png?v=1778025095'  },
      { name: 'Satin Gold', hex: '#C9A84C', surcharge: 315, tier: 'Premium', variantId: '42244811096146', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-satin-gold-500.jpg?v=1778032364', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motb0msa.png?v=1778026412'  },
      /* Brushed Stainless $660 */
      { name: 'Brushed Stainless*', hex: '#C0C0C0', surcharge: 660, tier: 'Premium', variantId: '42244811128914', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ef-swatch-500-brushed-stainless-500.jpg?v=1778032374', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motb22fy.png?v=1778026480'  },
      /* Wood Grain */
      { name: 'Wood Grain – Walnut', hex: '#5B3A22', surcharge: 1500, tier: 'Wood Grain', variantId: '42244811161682', img: 'https://product-options-img.avisplus.io/dea3576e-57ee-4c55-9762-cd856a5bf704/getimg_ai_img-c9c29jwb4ix7a4maq5e6j_1771266122162x300.jpg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800_55f5c735-4e0d-4489-839c-c4160f86157e.png?v=1778033535' },
      { name: 'Wood Grain – White Oak', hex: '#C4A96A', surcharge: 1500, tier: 'Wood Grain', variantId: '42287868837970', img: 'https://product-options-img.avisplus.io/dea3576e-57ee-4c55-9762-cd856a5bf704/white_oak_1771266060687x300.jpg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800_804de7e6-06da-468f-bca6-785adebb1858.png?v=1778033613' }
    ],
    addons: {
      brackets: {
        title: 'Decorative Brackets',
        options: [
          { name: 'No Thank You', surcharge: 0, img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723939139180_EFLOGO.jpg' },
          { name: 'Industrial', surcharge: 190, variantId: '42244811227218', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723934188971_idgqPHqXTGgXxcbkxVwIDIA.jpg' },
          { name: 'Square', surcharge: 190, variantId: '42244811259986', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723934191278_UMfuvHplRYWnekIIvDEik.jpg' }
        ]
      },
      banding: {
        title: 'Decorative Banding',
        options: [
          { name: 'No Thank You', surcharge: 0, img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723939156951_EFLOGO.jpg' },
          { name: 'Blacksmith', surcharge: 175, variantId: '42244811325522', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723934417737_KAWeOCwUhIZkgOvvrCjY.jpg' },
          { name: 'Old World', surcharge: 175, variantId: '42244811358290', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723934421021_JlfZmiwXNGTGMpHjzqQ.jpg' },
          { name: 'Aged Iron', surcharge: 385, variantId: '42244811391058', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723934423793_gVsFROfpzfAROpQIYqVWl.jpg' }
        ]
      },
      bluetooth: {
        title: 'Bluetooth & Lights',
        options: [
          { name: 'No Thank You', surcharge: 0, img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723939171508_EFLOGO.jpg' },
          { name: 'LED Lights', surcharge: 185, variantId: '42244811456594', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723934938840_ybxRSjoWrsevUUFCEV.jpg' },
          { name: 'LED Lights + Speakers', surcharge: 480, variantId: '42244811489362', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723934935645_EZVmINRzEkMdPcFcaP.jpg' }
        ]
      }
    }
  };

  /* â”€â”€ Per-product config (set in Liquid above) â”€â”€ */
  var CFG = window.__EFM_CONFIG || {
    disableFinishes: false, disableLED: false, disableSpeakers: false,
    disableAddons: false, palette: 'default'
  };

  /* Apply config: filter bluetooth options, swap palette, default state for skipped steps */
  if (CFG.disableLED && CFG.disableSpeakers) {
    /* Both gone — keep only "No Thank You" */
    DATA.addons.bluetooth.options = DATA.addons.bluetooth.options.filter(function(o) {
      return o.name === 'No Thank You';
    });
  } else if (CFG.disableSpeakers) {
    /* Drop the speakers combo; keep LED-only */
    DATA.addons.bluetooth.options = DATA.addons.bluetooth.options.filter(function(o) {
      return o.name !== 'LED Lights + Speakers';
    });
  } else if (CFG.disableLED) {
    /* Drop LED-only AND combo (speakers require LED in this product line) */
    DATA.addons.bluetooth.options = DATA.addons.bluetooth.options.filter(function(o) {
      return o.name === 'No Thank You';
    });
  }

  if (CFG.palette === 'carolina') {
    /* Full Carolina door finish palette — pulled from EF_CFG_DATA["Fireplace Doors - Carolina"].
       31 finishes across 4 tiers: Powder Coat (free), Premium (+$100-350), Handcrafted (+$350),
       Boutique (+$650). Images are real swatch photos served from product-options-img.avisplus.io
       and Shopify CDN. */
    DATA.colors = [
      { name: 'Rustic Black', surcharge: 0, tier: "Powder Coat", img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/7095025746_1723952554726_SfqONEedSZerBXdhiF_1.jpg?v=1775652611', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-rustic-black.png?v=1778541878'  },
      { name: 'Textured Black', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952557448_OhpkeByxxOmthcnmZhuV.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-textured-black.png?v=1778541882'  },
      { name: 'Brite Black', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952560011_agLlipWohnKOFKoDMTKn.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-brite-black.png?v=1778541885'  },
      { name: 'Ancient Age', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952562335_PBiZyrQrsoSEPntuIegy.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-ancient-age.png?v=1778541888'  },
      { name: 'Bronze Burst', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952564948_vEpRWIJSbHpSBwggta.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-bronze-burst.png?v=1778541891'  },
      { name: 'Classic Bronze', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952568068_QEwLvhBvZMUhifgZNRNX.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-classic-bronze.png?v=1778541894'  },
      { name: 'Cast Bronze', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952572169_OYUyDHloxaKCZbsVxGaV.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-cast-bronze.png?v=1778541898'  },
      { name: "Gold Rush", surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952635941_DCzNxrVLbjtvlUBshfMbYs.jpg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-gold-rush.png?v=1778541901' },
      { name: 'Toffee', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952640065_LKVsOgpmgjIpgyOapq.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-toffee.png?v=1778541905'  },
      { name: 'Solar Bronze', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952643375_zSOJiqGycJnRKDaYhleUY.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-solar-bronze.png?v=1778541908'  },
      { name: 'Copper Vein', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952650931_ardzOIhEqMPjDWLulE.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-copper-vein.png?v=1778541911'  },
      { name: 'Mahogany', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952654793_srPiQqZBNCQZKjVXjNHGi.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-mahogany.png?v=1778541915'  },
      { name: "Root Beer", surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952662621_CPplFrwtHwDjptuaFj.jpg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-root-beer.png?v=1778541918' },
      { name: 'Espresso', surcharge: 0, tier: "Powder Coat", img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/espresso.jpg?v=1780342175', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-espresso.png?v=1778541921'  },
      { name: "Flint", surcharge: 0, tier: "Powder Coat", img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/flint_steel.jpg?v=1780339907', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-flint.png?v=1778541924' },
      { name: 'Dark Pewter', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952682716_eTIUaQlmZQgvsHWGBsf.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-dark-pewter.png?v=1778541928'  },
      { name: 'Natural Iron', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952685161_wiPEKcNZiBsPAjyJup.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-natural-iron.png?v=1778541932'  },
      { name: 'Vintage Iron', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952690929_vJXldwqfIpkRtAlWxcksGo.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-vintage-iron.png?v=1778541935'  },
      { name: "Silver", surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1723952694772_OzttuSUEgyQalJPUwnFK.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-silver.png?v=1778541939' },
      { name: 'Honey Maple', surcharge: 0, tier: "Powder Coat", img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1724111316115_Powder Coat  Honey Maple.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-honey-maple.png?v=1778541942'  },
      { name: 'Shark Skin', surcharge: 100, tier: "Premium", variantId: '42385749540946', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1724128637449_isan Premier  Shark Skin.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-shark-skin.png?v=1778541946'  },
      { name: 'Satin Nickel', surcharge: 350, tier: "Premium", variantId: '42385749573714', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1724128537884_l Metallic  Satin Nickel.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-satin-nickel.png?v=1778541949'  },
      { name: 'Black Nickel', surcharge: 350, tier: "Premium", variantId: '42385749606482', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1724128381564_l Metallic  Black Nickel.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-black-nickel.png?v=1778541952'  },
      { name: 'Rustic Copper', surcharge: 350, tier: "Handcrafted", variantId: '42385749639250', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1724128587349_d Crafted  Rustic Copper.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-rustic-copper.png?v=1778541955' },
      { name: 'Antique Iron', surcharge: 350, tier: "Handcrafted", variantId: '42385749672018', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1724128580622_nd Crafted  Antique Iron.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-antique-iron.png?v=1778541959' },
      { name: 'Forged Iron', surcharge: 350, tier: "Handcrafted", variantId: '42385749704786', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1724128573684_and Crafted  Forged Iron.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-forged-iron.png?v=1778541962' },
      { name: 'Burnished Bronze', surcharge: 350, tier: "Handcrafted", variantId: '42385749737554', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1724128567007_rafted  Burnished Bronze.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-burnished-bronze.png?v=1778541965'  },
      { name: 'Burnished Copper', surcharge: 350, tier: "Handcrafted", variantId: '42385749803090', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1724128560303_rafted  Burnished Copper.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-burnished-copper.png?v=1778541969'  },
      { name: 'Red Wood', surcharge: 350, tier: "Handcrafted", variantId: '42385749868626', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1724128553619_Hand Crafted  Red Wood.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-red-wood.png?v=1778541972' },
      { name: 'Silver Birch', surcharge: 350, tier: "Handcrafted", variantId: '42385749901394', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1724128547312_nd Crafted  Silver Birch.jpeg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-silver-birch.png?v=1778541975' },
      { name: 'Oil Rubbed Bronze', surcharge: 650, tier: "Handcrafted", variantId: '42385749934162', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1724128352740_ayqFUNZRKdRhiqfjUIGR.jpg', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/ds-mantel-final-oil-rubbed-bronze.png?v=1778541979'  }
    ];
  }

  /* Wood color palette (Transitional product only — set via CFG.showWoodColor).
     3 options pulled from Avis Stoll Transitional option_set. All $0. */
  var WOOD_COLORS = [
    { name: 'Salon',    img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1726412647184_eRKzlPjUGnHjbIYP.jpg' },
    { name: 'Engadina', img: 'https://product-options-img.avisplus.io/7095025746/7095025746_1726412649458_CcZVXIxPkcIgBNZektm.jpg' },
    { name: 'Espresso', img: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/si-inserts-espresso-01a.jpg?v=1785183535', previewImg: 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/final-800-motagejr.png?v=1778025469'  }
  ];

  /* Build set of hidden steps for nav skip logic */
  var SKIPPED_STEPS = {};
  if (CFG.disableFinishes) SKIPPED_STEPS[2] = true;
  if (CFG.disableAddons)   SKIPPED_STEPS[3] = true;

  /* Hide skipped steps' DOM nodes + progress nodes immediately so nothing flashes */
  Object.keys(SKIPPED_STEPS).forEach(function(s) {
    var stepEl = document.querySelector('.ef-cfg-mantel-step[data-step="' + s + '"]');
    if (stepEl) stepEl.style.display = 'none';
    var nodeEl = document.querySelector('.ef-cfg-mantel-progress__node[data-step="' + s + '"]');
    if (nodeEl) nodeEl.style.display = 'none';
  });

  /* Visible step list — used for "Step X of N" calculations */
  var VISIBLE_STEPS = [1, 2, 3, 4].filter(function(s) { return !SKIPPED_STEPS[s]; });
  /* Update progress fraction "of N" */
  var ofN = document.querySelector('.ef-cfg-mantel-progress__frac span:last-child');
  if (ofN) ofN.textContent = VISIBLE_STEPS.length;

  /* Patch Next-button labels based on the actual next-visible step.
     E.g. if Step 2 (Color) is skipped, "Next: Color" on Step 1 becomes
     "Next: Add-ons" or "Continue to Review". */
  function _efmNextLabel(fromStep) {
    var n = fromStep + 1;
    while (n <= 4 && SKIPPED_STEPS[n]) n++;
    /* Shorter mobile-friendly labels — no "Next:" prefix (was truncating
       on 375px viewport). 2026-05-03. */
    if (n === 2) return 'Color';
    if (n === 3) return 'Add-ons';
    if (n === 4) return 'Review';
    return 'Continue';
  }
  var _efmArrowSvg = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>';
  ['efmNext1', 'efmNext2', 'efmNext3'].forEach(function(id, idx) {
    var btn = document.getElementById(id);
    if (btn) btn.innerHTML = _efmNextLabel(idx + 1) + ' ' + _efmArrowSvg;
  });

  /* â”€â”€ State â”€â”€ */
  var state = {
    step: 1,
    length: null,       /* { rangeIdx, inch, surcharge, variantId } */
    height: null,       /* { label, surcharge, variantId } */
    depth: null,        /* { label, surcharge, variantId } */
    color: null,        /* { name, surcharge, variantId } */
    wood_color: null,   /* { name, img } — only used when CFG.showWoodColor */
    brackets: { name: 'No Thank You', surcharge: 0, variantId: null, label: 'No Thank You' },
    banding:  { name: 'No Thank You', surcharge: 0, variantId: null, label: 'No Thank You' },
    bluetooth:{ name: 'No Thank You', surcharge: 0, variantId: null, label: 'No Thank You' }
  };

  /* When finishes are skipped, default state.color so review/total still render.
     The product's name itself indicates the finish (e.g. "Wood Grain – White Oak"). */
  if (CFG.disableFinishes) {
    state.color = {
      name: window.EF_MANTELS_DATA.prodTitle,
      label: 'Included with product',
      hex: '#888',
      surcharge: 0,
      variantId: null
    };
  }

  /* â”€â”€ DOM refs â”€â”€ */
  var $wrap       = document.getElementById('efmWrap');
  var $stepCur    = document.getElementById('efmStepCur');
  var $fill       = document.getElementById('efmFill');
  var $barFill    = document.getElementById('efmBarFill');
  var $totalAmt   = document.getElementById('efmTotalAmount');
  var $totalBar   = document.getElementById('efmTotalBar');

  /* â”€â”€ Helpers â”€â”€ */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  /* "Included" reads softer for free swatches/options than "$0" (which feels
     like a tax line). User feedback 2026-05-03 — swatches use Included. */
  function fmt(n) { return n === 0 ? 'Included' : '+$' + n.toLocaleString('en-US'); }
  function fmtDollar(n) { return '+$' + n.toLocaleString('en-US'); }

  function calcTotal() {
    var t = 0;
    if (state.length)   t += state.length.surcharge;
    if (state.height)   t += state.height.surcharge;
    if (state.depth)    t += state.depth.surcharge;
    if (state.color)    t += state.color.surcharge;
    t += state.brackets.surcharge;
    t += state.banding.surcharge;
    t += state.bluetooth.surcharge;
    return t;
  }

  /* Luxury convention: round prices show no .00 (matches doors PDP + HermÃ¨s,
     Apple, Tesla, RH). Non-round shows 2 decimals. User feedback 2026-05-03. */
  function fmtPrice(n) {
    return n % 1 === 0
      ? n.toLocaleString('en-US')
      : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function updateTotal() {
    var surcharge = calcTotal();
    var basePrice = (window.EF_MANTELS_DATA.basePrice / 100);
    var total = basePrice + surcharge;

    /* 2026-05-06 — price box now duplicated per step (above each Next button,
       matching doors). Switched from getElementById â†’ querySelectorAll so all
       4 instances stay in sync. Original IDs kept for backwards compat. */
    var basePriceEls = document.querySelectorAll('.efm-base-price, #efmBasePrice');
    basePriceEls.forEach(function(el) { el.textContent = '$' + fmtPrice(basePrice); });

    var linesEls = document.querySelectorAll('.efm-surcharge-lines, #efmSurchargeLines');
    linesEls.forEach(function(linesEl) {
      linesEl.innerHTML = '';
      if (state.length && state.length.surcharge > 0)
        addLine(linesEl, '+ Size (Length ' + state.length.inch + '")', '+$' + state.length.surcharge.toLocaleString());
      if (state.height && state.height.surcharge > 0)
        addLine(linesEl, '+ Height (' + state.height.label + ')', '+$' + state.height.surcharge.toLocaleString());
      if (state.depth && state.depth.surcharge > 0)
        addLine(linesEl, '+ Depth (' + state.depth.label + ')', '+$' + state.depth.surcharge.toLocaleString());
      if (state.color && state.color.surcharge > 0)
        addLine(linesEl, '+ Color (' + state.color.label + ')', '+$' + state.color.surcharge.toLocaleString());
      if (state.brackets.surcharge > 0)
        addLine(linesEl, '+ Brackets (' + state.brackets.label + ')', '+$' + state.brackets.surcharge.toLocaleString());
      if (state.banding.surcharge > 0)
        addLine(linesEl, '+ Banding (' + state.banding.label + ')', '+$' + state.banding.surcharge.toLocaleString());
      if (state.bluetooth.surcharge > 0)
        addLine(linesEl, '+ Bluetooth (' + state.bluetooth.label + ')', '+$' + state.bluetooth.surcharge.toLocaleString());
    });

    var totalEls = document.querySelectorAll('.efm-total-price, #efmTotalPrice');
    totalEls.forEach(function(el) { el.textContent = '$' + fmtPrice(total); });

    /* Update header price (under stars) */
    var headerPrice = document.getElementById('efmHeaderPrice');
    if (headerPrice) headerPrice.textContent = '$' + fmtPrice(total);

    /* 2026-05-11 — Sync compare-at + Save badge proportionally with options.
       Ratio-based: discount % at base = (compare - base) / compare stays
       constant across total. So bigger orders = bigger absolute savings,
       matching the "best deal at scale" UX of premium custom configurators
       (parity with doors PDP scaling logic). */
    var compareAtBase = (window.EF_MANTELS_DATA.compareAtPrice || 0) / 100;
    if (compareAtBase > basePrice) {
      var ratio = compareAtBase / basePrice;
      var compareAtNow = Math.round(total * ratio);
      var savingsNow = compareAtNow - total;
      if (compareAtNow > total) {
        document.querySelectorAll('.ef-mantel-price-compare').forEach(function(el){
          el.textContent = '$' + fmtPrice(compareAtNow);
          el.style.display = '';
        });
        document.querySelectorAll('.ef-mantel-price-save').forEach(function(el){
          el.textContent = 'Save $' + fmtPrice(savingsNow);
          el.style.display = '';
        });
      } else {
        document.querySelectorAll('.ef-mantel-price-compare').forEach(function(el){ el.style.display = 'none'; });
        document.querySelectorAll('.ef-mantel-price-save').forEach(function(el){ el.style.display = 'none'; });
      }
    }

    /* Update Add to Cart button with price */
    var submitBtn = document.getElementById('efmSubmit');
    if (submitBtn && !submitBtn.disabled) submitBtn.textContent = 'Add to Cart \u2014 $' + fmtPrice(total);

    /* Update old bar if exists */
    if ($totalAmt) $totalAmt.textContent = surcharge === 0 ? 'Base Price' : fmtDollar(surcharge);

    /* CRO 2026-04-29 — broadcast live total for ef-pd2-sticky-atc.js sticky bar.
       totalCents = total dollars Ã— 100 (matches doors PDP convention).
       2026-05-06 — also broadcast allSelectionsMade so sticky unlocks based on
       selections rather than navigation to review (4th step). */
    var _allMade = !!(state.length && state.height && state.depth && state.color);
    try {
      window.dispatchEvent(new CustomEvent('ef-cfg:price-changed', {
        detail: { totalCents: Math.round(total * 100), allSelectionsMade: _allMade }
      }));
    } catch (_) {}
  }

  function addLine(container, label, value) {
    var div = document.createElement('div');
    div.style.cssText = 'display:flex;justify-content:space-between;align-items:baseline;gap:12px;padding:4px 0;font-family:Inter,sans-serif;font-size:13px;color:#5C5852;max-width:100%;';
    div.innerHTML = '<span style="flex:1 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + label + '</span><span style="color:#8A6A43;font-weight:500;flex-shrink:0;white-space:nowrap;">' + value + '</span>';
    container.appendChild(div);
  }

  /* â”€â”€ Progress â”€â”€ */
  function updateProgress() {
    var nodes = $$('.ef-cfg-mantel-progress__node');
    var cur = state.step;
    /* Display "Step X of N" using position in visible-steps list, not raw step # */
    var visibleIdx = VISIBLE_STEPS.indexOf(cur);
    if ($stepCur) $stepCur.textContent = visibleIdx >= 0 ? (visibleIdx + 1) : cur;

    nodes.forEach(function(node) {
      var s = parseInt(node.getAttribute('data-step'));
      node.classList.remove('is-active', 'is-done');
      if (s < cur) node.classList.add('is-done');
      else if (s === cur) node.classList.add('is-active');
    });

    /* Track fill (between circles) — clip to half-slot on each side so line
       starts AT circle 1 center and ends AT circle N center (no overhang past
       extreme circles). Mirrors doors PDP fix. User feedback 2026-05-03. */
    var visTotal = Math.max(VISIBLE_STEPS.length, 1);
    var halfSlotPct = (50 / visTotal) + '%';
    var trackEls = document.querySelectorAll('.ef-cfg-mantel-progress__track');
    trackEls.forEach(function(el) {
      el.style.setProperty('left', halfSlotPct, 'important');
      el.style.setProperty('right', halfSlotPct, 'important');
    });
    if ($fill) {
      $fill.style.setProperty('left', halfSlotPct, 'important');
      var span = Math.max(VISIBLE_STEPS.length - 1, 1);
      var trackPct = (visibleIdx >= 0 ? visibleIdx : 0) / span * 100;
      /* Width capped to (N-1)/N * pct so fill doesn't overflow past last circle */
      var fillWidth = ((visTotal - 1) / visTotal) * trackPct + '%';
      $fill.style.setProperty('width', fillWidth, 'important');
    }

    /* Bottom progress bar — uses (idx+1)/N formula matching doors PDP so step 1
       already shows 1/N filled. User feedback 2026-05-03. */
    var barPct = ((Math.max(visibleIdx, 0) + 1) / visTotal) * 100;
    if ($barFill) $barFill.style.width = barPct + '%';

    /* Sticky top progress strip — segment fill per visible step. Clone of
       doors PDP `.ef-cfg-strip` behavior (2026-05-03 parity). */
    var strip = document.getElementById('efmStrip');
    if (strip) {
      var segs = strip.querySelectorAll('.ef-cfg-mantel-strip__seg');
      segs.forEach(function(seg, i) {
        seg.classList.remove('is-done', 'is-active');
        if (i < visibleIdx) seg.classList.add('is-done');
        else if (i === visibleIdx) seg.classList.add('is-active');
      });
    }
  }

  /* Build sticky top strip on init — one segment per visible step.
     2026-05-03 — uses doors-style robust header detection (was simpler
     selector that didn't match Prestige's actual header structure). */
  function buildMantelStrip() {
    var strip = document.getElementById('efmStrip');
    if (!strip) { console.warn('[mantel-strip] #efmStrip not found in DOM'); return; }
    var n = (typeof VISIBLE_STEPS !== 'undefined' && VISIBLE_STEPS.length) ? VISIBLE_STEPS.length : 4;
    var html = '';
    for (var i = 0; i < n; i++) html += '<div class="ef-cfg-mantel-strip__seg" data-vis-step="' + i + '"></div>';
    strip.innerHTML = html;

    /* Robust header height detection (clone of doors syncStripOffset). Tries
       multiple selectors that Prestige + EF utility bar combinations might
       match. Re-runs on resize + load (some hidden headers expand later). */
    function syncOffset() {
      var hdr = document.querySelector('header.shopify-section, #shopify-section-header, header[role="banner"], .header, header');
      var h = 0;
      if (hdr) h = Math.round(hdr.getBoundingClientRect().height);
      if (!h || h < 30) h = 64;
      document.documentElement.style.setProperty('--ef-cfg-strip-offset', h + 'px');
    }
    syncOffset();
    window.addEventListener('resize', syncOffset, { passive: true });
    window.addEventListener('load', syncOffset, { once: true });

    strip.classList.add('is-ready');
    /* Force initial paint of correct active segment */
    if (typeof updateProgress === 'function') updateProgress();
  }
  buildMantelStrip();

  /* â”€â”€ Navigation â”€â”€ */
  /* Skip-aware goToStep: if target step is hidden by config, walk in `dir`
     direction (default forward) until we hit a visible step. */
  function nextVisible(n, dir) {
    dir = dir || 1;
    while (n >= 1 && n <= 4 && SKIPPED_STEPS[n]) n += dir;
    if (n < 1 || n > 4) return null;
    return n;
  }

  /* Expose goToStep globally so inline onclick handlers in review table work */
  window.goToStep = goToStep;
  function goToStep(n, dir) {
    n = nextVisible(n, dir);
    if (n === null) return;
    /* 2026-05-06 — hide any swatch popup before navigating. Without this, popup
       from step 2 stayed visible on step 4 review (reported by user). The
       hideSwatchPopup helper is scoped inside buildColors IIFE; expose it on
       window so this outer goToStep can call it. Defensive — try/catch in case
       buildColors hasn't initialized yet. */
    try { if (typeof window.efmHideSwatchPopup === 'function') window.efmHideSwatchPopup(); } catch(_) {}
    state.step = n;
    $$('.ef-cfg-mantel-step').forEach(function(el) { el.classList.remove('is-visible'); });
    var target = document.querySelector('.ef-cfg-mantel-step[data-step="' + n + '"]');
    if (target) target.classList.add('is-visible');

    updateProgress();
    updateTotal();

    /* Build review on step 4 */
    if (n === 4) buildSummary();

    /* Old efmStickyATC toggling neutralized 2026-04-29 — replaced by always-visible
       #efPd2Sticky bar from doors PDP. New bar reads state via 'ef-cfg:state-changed'
       event dispatched below. Click mirroring â†’ #efmSubmit handled in
       assets/ef-pd2-sticky-atc.js (mantels fallback added). */

    /* Scroll to top of configurator */
    $wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });

    /* CRO 2026-04-29 — broadcast state for ef-pd2-sticky-atc.js sticky bar.
       Uses VISIBLE_STEPS so cfg variants with disableFinishes/disableAddons report
       correctly. cfgType: 'cfg-simple' â†’ minToUnlock = 1 in sticky logic. */
    try {
      var _vIdx = (typeof VISIBLE_STEPS !== 'undefined') ? VISIBLE_STEPS.indexOf(n) : (n - 1);
      var _vTot = (typeof VISIBLE_STEPS !== 'undefined') ? VISIBLE_STEPS.length : 4;
      var _basePrice = (window.EF_MANTELS_DATA.basePrice / 100);
      var _totalCents = Math.round((_basePrice + calcTotal()) * 100);
      /* 2026-05-06 — cfgType: 'cfg-mantels' (NOT 'cfg-simple') so sticky's
         1-step-unlock shortcut does not fire. Sticky now requires either
         allSelectionsMade (length + height + depth + color all picked) or
         stepsDone >= displayTotal. Step 1 alone is no longer enough to ATC. */
      var _allMade = !!(state.length && state.height && state.depth && state.color);
      window.dispatchEvent(new CustomEvent('ef-cfg:state-changed', {
        detail: {
          curStep: _vIdx,
          totalSteps: _vTot,
          totalSkipped: 0,
          isLast: (n === 4),
          totalCents: _totalCents,
          cfgType: 'cfg-mantels',
          allSelectionsMade: _allMade
        }
      }));
    } catch (_) {}
  }

  /* Progress node click — allow jumping back to completed steps */
  $$('.ef-cfg-mantel-progress__node').forEach(function(node) {
    node.addEventListener('click', function() {
      var s = parseInt(node.getAttribute('data-step'));
      if (s < state.step) goToStep(s);
    });
  });

  /* Back buttons — pass dir=-1 so nextVisible walks BACKWARD past skipped steps */
  $$('[data-back]').forEach(function(btn) {
    btn.addEventListener('click', function() { goToStep(state.step - 1, -1); });
  });

  /* ================================================================
     STEP 1 — Dimensions (Length + Height + Depth)
     ================================================================ */
  (function buildDimensions() {
    /* --- Length dropdown --- */
    /* Clear validation error on a dropdown */
    function clearFieldError(sel) {
      var field = sel.closest('.efm-dim-field');
      if (field) {
        field.style.borderColor = '';
        field.style.boxShadow = '';
      } else {
        sel.style.borderColor = '';
        sel.style.boxShadow = '';
      }
      var err = document.getElementById('efmErr_' + sel.id);
      if (err) err.remove();
    }

    /* Update summary bar + card state */
    function updateDimSummary(sel, summaryId, fieldId) {
      var val = sel.value;
      var field = document.getElementById(fieldId);
      var summary = document.getElementById(summaryId);
      if (!field || !summary) return;

      if (val) {
        sel.classList.remove('empty');
        field.classList.add('has-value');
        var text = sel.options[sel.selectedIndex].text;
        var inch = text.match(/^[\d\s\/]+"/);
        summary.textContent = inch ? inch[0] : text;
        summary.classList.remove('empty');
      } else {
        sel.classList.add('empty');
        field.classList.remove('has-value');
        summary.innerHTML = '&mdash;';
        summary.classList.add('empty');
      }
    }

    /* â”€â”€ Dynamic 3D shelf diagram — true proportions â”€â”€ */
    var svgDims = { len: 48, hgt: 5, dep: 8 }; /* defaults (inches) */

    function drawShelf() {
      var L = svgDims.len, H = svgDims.hgt, D = svgDims.dep;

      /*
       * Single scale factor (px per inch) so all 3 dimensions
       * are in true proportion. We fit the longest axis (length)
       * into ~280px max, then height & depth follow naturally.
       * Clamp height so 2" shelves are still visible.
       */
      var scale = Math.min(280 / L, 8);  /* max 8 px/inch for short shelves */
      var w = L * scale;                  /* front face width */
      var h = Math.max(H * scale, 6);    /* front face height, min 6px visible */
      var d = D * scale;                  /* depth in real scale */

      /* Isometric projection: depth â†’ 30° angle */
      var dx = d * 0.75;   /* horizontal projection */
      var dy = d * 0.42;   /* vertical projection */

      /* Compute bounding box and center in SVG */
      var totalW = w + dx;
      var totalH = dy + h;
      var pad = 16;
      var vbW = totalW + pad * 2;
      var vbH = totalH + pad * 2;

      var svg = document.getElementById('efmShelfSvg');
      svg.setAttribute('viewBox', '0 0 ' + vbW + ' ' + vbH);

      /* Front-left corner anchored with padding */
      var flx = pad;
      var fly = pad + dy; /* top-front starts after depth projection */

      var frx = flx + w;
      var blx = flx + dx;
      var bly = fly - dy;
      var brx = frx + dx;
      var bry = fly - dy;
      var fbly = fly + h;
      var fbry = fly + h;
      var bbry = bry + h;

      /* Top face */
      document.getElementById('efmSvgTop').setAttribute('d',
        'M' + flx + ' ' + fly + ' L' + frx + ' ' + fly +
        ' L' + brx + ' ' + bry + ' L' + blx + ' ' + bly + ' Z');
      /* Front face */
      document.getElementById('efmSvgFront').setAttribute('d',
        'M' + flx + ' ' + fly + ' L' + frx + ' ' + fly +
        ' L' + frx + ' ' + fbry + ' L' + flx + ' ' + fbly + ' Z');
      /* Side face */
      document.getElementById('efmSvgSide').setAttribute('d',
        'M' + frx + ' ' + fly + ' L' + brx + ' ' + bry +
        ' L' + brx + ' ' + bbry + ' L' + frx + ' ' + fbry + ' Z');

      /* Mirror into the parametric 3D preview (true proportions). No-op if 3D didn't init. */
      if (window.EFMantel3D) { try { window.EFMantel3D.setDims(L, H, D); } catch (e) {} }
    }

    /* Initial draw */
    drawShelf();

    var lengthSelect = document.getElementById('efmLengthSelect');
    if (lengthSelect) {
      lengthSelect.addEventListener('change', function() {
        clearFieldError(lengthSelect);
        updateDimSummary(lengthSelect, 'efmSumLen', 'efmDfLen');
        var opt = lengthSelect.options[lengthSelect.selectedIndex];
        var inch = parseInt(lengthSelect.value);
        var surcharge = parseInt(opt.getAttribute('data-price')) || 0;
        var vid = DATA.lengthVariants[String(inch)] || null;
        state.length = { inch: inch, surcharge: surcharge, variantId: vid };
        svgDims.len = inch;
        drawShelf();
        checkDimsComplete();
        updateTotal();
      });
    }

    /* --- Height dropdown --- */
    var heightSel = document.getElementById('efmHeight');
    if (heightSel) {
      heightSel.addEventListener('change', function() {
        clearFieldError(heightSel);
        updateDimSummary(heightSel, 'efmSumHgt', 'efmDfHgt');
        var idx = parseInt(heightSel.value);
        if (!isNaN(idx) && DATA.heights[idx]) {
          var h = DATA.heights[idx];
          state.height = { label: h.label, surcharge: h.surcharge, variantId: h.variantId || null };
          var hInch = parseFloat(h.label);
          if (hInch) { svgDims.hgt = hInch; drawShelf(); }
        }
        checkDimsComplete();
        updateTotal();
      });
    }

    /* --- Depth dropdown --- */
    var depthSel = document.getElementById('efmDepth');
    if (depthSel) {
      depthSel.addEventListener('change', function() {
        clearFieldError(depthSel);
        updateDimSummary(depthSel, 'efmSumDep', 'efmDfDep');
        var idx = parseInt(depthSel.value);
        if (!isNaN(idx) && DATA.depths[idx]) {
          var d = DATA.depths[idx];
          state.depth = { label: d.label, surcharge: d.surcharge, variantId: d.variantId || null };
          var dInch = parseFloat(d.label);
          if (dInch) { svgDims.dep = dInch; drawShelf(); }
        }
        checkDimsComplete();
        updateTotal();
      });
    }

    /* --- Check all 3 dimensions filled --- */
    var next1Btn = document.getElementById('efmNext1');
    function checkDimsComplete() {
      /* No longer disabling — button is always black, validates on click */
    }

    if (next1Btn) {
      next1Btn.addEventListener('click', function() {
        if (state.length && state.length.inch && state.height && state.depth) {
          goToStep(2);
        } else {
          /* Highlight missing dropdowns */
          var fields = [
            { id: 'efmLengthSelect', cardId: 'efmDfLen', filled: state.length && state.length.inch, label: 'Shelf Length' },
            { id: 'efmHeight', cardId: 'efmDfHgt', filled: !!state.height, label: 'Shelf Height' },
            { id: 'efmDepth', cardId: 'efmDfDep', filled: !!state.depth,  label: 'Shelf Depth' }
          ];
          for (var i = 0; i < fields.length; i++) {
            var sel = document.getElementById(fields[i].id);
            var card = document.getElementById(fields[i].cardId);
            if (!sel) continue;
            var target = card || sel;
            if (!fields[i].filled) {
              target.style.borderColor = '#C0533A';
              target.style.boxShadow = '0 0 0 2px rgba(192,83,58,0.15)';
              /* Show error below */
              var errId = 'efmErr_' + fields[i].id;
              if (!document.getElementById(errId)) {
                var err = document.createElement('div');
                err.id = errId;
                err.style.cssText = 'color:#C0533A;font-size:12px;margin-top:4px;font-weight:500;padding:0 16px 8px;';
                err.textContent = 'Please select ' + fields[i].label.toLowerCase();
                target.appendChild(err);
              }
              (function(targetRef, eid) {
                setTimeout(function() {
                  targetRef.style.borderColor = '';
                  targetRef.style.boxShadow = '';
                  var e = document.getElementById(eid);
                  if (e) e.remove();
                }, 4000);
              })(target, errId);
              if (i === 0 || (!fields[0].filled && i === 0)) sel.focus();
            } else {
              target.style.borderColor = '';
              target.style.boxShadow = '';
            }
          }
          /* Scroll to first missing */
          for (var j = 0; j < fields.length; j++) {
            if (!fields[j].filled) {
              var el = document.getElementById(fields[j].cardId) || document.getElementById(fields[j].id);
              if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
              break;
            }
          }
        }
      });
    }
  })();

  /* ================================================================
     STEP 2 — Color Swatches
     ================================================================ */
  /* ================================================================
     Wood Color picker (Transitional product only)
     Built once on init. Selection required before Next on Step 2.
     ================================================================ */
  /* ── Per-product finish-preview override (2026-07-27) ──
     window.EF_MANTEL_FINISH_PREVIEWS (assets/ef-mantel-finish-previews.js) maps
     product handle -> { key: url } where key is "<Finish Name>" (Stoll decorated
     mantels) or "<Wood Name>|<Finish Name>" (Transitional wood+metal combos).
     Lets products that SHARE the default palette swap the gallery to renders of
     THEIR OWN shelf instead of the generic bare-steel previewImg. */
  var EFM_HANDLE = (function() {
    try {
      var el = document.getElementById('efGallerySwiper');
      return (el && el.getAttribute('data-product-handle')) || '';
    } catch(e) { return ''; }
  })();
  function efmPreviewOverride(finishName) {
    try {
      var m = (window.EF_MANTEL_FINISH_PREVIEWS || {})[EFM_HANDLE];
      if (!m) return null;
      var wood = state.wood_color && state.wood_color.name;
      if (wood && finishName && m[wood + '|' + finishName]) return m[wood + '|' + finishName];
      if (finishName && m[finishName]) return m[finishName];
      /* wood picked but no finish yet — show wood in the flat included finish */
      if (wood && !finishName && m[wood + '|Matte Black']) return m[wood + '|Matte Black'];
      return null;
    } catch(e) { return null; }
  }
  var _efmCurColorData = null; /* last-selected finish colorData — wood-change refresh */

  (function buildWoodColor() {
    if (!CFG.showWoodColor) return;
    var section = document.getElementById('efmWoodSection');
    var grid = document.getElementById('efmWoodGrid');
    if (!section || !grid) return;
    section.style.display = '';

    grid.innerHTML = WOOD_COLORS.map(function(w) {
      var safe = (w.name || '').replace(/"/g, '&quot;');
      return '<button type="button" class="efm-wood-card" data-name="' + safe + '" data-img="' + (w.img || '') + '" aria-pressed="false">' +
        '<span class="efm-wood-card__swatch" style="background-image:url(' + (w.img || '').replace(/ /g,'%20') + ');"></span>' +
        '<span class="efm-wood-card__name">' + w.name + '</span>' +
      '</button>';
    }).join('');

    grid.addEventListener('click', function(e) {
      var card = e.target.closest('.efm-wood-card');
      if (!card) return;
      var name = card.getAttribute('data-name');
      var img = card.getAttribute('data-img');
      $$('.efm-wood-card', grid).forEach(function(c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      state.wood_color = { name: name, img: img };
      updateTotal();
      /* Refresh gallery preview for the new wood (combo render if available) */
      try { if (window.__efmRefreshPreview) window.__efmRefreshPreview(); } catch(e) {}
    });
  })();

  (function buildColors() {
    var tabEl = document.getElementById('efmFinishTabs');
    var gridEl = document.getElementById('efmSwatchGrid');

    /* Build tabs from unique tier values found in DATA.colors, preserving
       array order. Default Steel palette gives [Standard, Premium, Wood Grain].
       Carolina palette gives [Powder Coat, Premium, Handcrafted, Boutique]. */
    var seenTiers = {};
    var activeTiers = [];
    DATA.colors.forEach(function(c) {
      var t = c.tier || 'Standard';
      if (!seenTiers[t]) {
        seenTiers[t] = true;
        activeTiers.push({ key: t, label: t });
      }
    });
    if (!activeTiers.length) return;

    var activeTab = activeTiers[0].key;

    activeTiers.forEach(function(tier) {
      var btn = document.createElement('button');
      btn.className = 'efm-finish-tab' + (tier.key === activeTab ? ' is-active' : '');
      btn.textContent = tier.label;
      btn.dataset.tier = tier.key;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('type', 'button');
      btn.addEventListener('click', function() {
        try { hideSwatchPopup(); } catch(e) {}
        tabEl.querySelectorAll('.efm-finish-tab').forEach(function(t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        showSwatchesForTier(tier.key);
      });
      tabEl.appendChild(btn);
    });

    /* Swatch Popup helpers */
    var swatchPopup = document.getElementById('efmSwatchPopup');
    var popupImg = swatchPopup.querySelector('.ef-cfg-mantel-swatch-popup__img');
    var popupName = swatchPopup.querySelector('.ef-cfg-mantel-swatch-popup__name');
    var popupPrice = swatchPopup.querySelector('.ef-cfg-mantel-swatch-popup__price');
    var popupBadge = document.getElementById('efmSwatchPopupBadge');
    var popupStat = document.getElementById('efmSwatchPopupStat');

    /* Top-3 popular finishes (mirrors doors PDP). */
    var EFM_POPULAR_FINISHES = {
      'matte black':       { rank: 1, pct: 47 },
      'textured black':    { rank: 2, pct: 18 },
      'charcoal':          { rank: 3, pct: 11 }
    };

    function showSwatchPopup(btn, colorData) {
      if (colorData.img) {
        popupImg.src = colorData.img.replace(/ /g, '%20');
        popupImg.alt = colorData.name;
        popupImg.style.display = '';
      } else {
        popupImg.style.display = 'none';
      }
      popupName.textContent = colorData.name;
      popupPrice.textContent = colorData.surcharge ? fmt(colorData.surcharge) : 'Included';

      /* Populate badge + stat for popular finishes */
      var key = (colorData.name || '').toLowerCase().trim();
      var pop = EFM_POPULAR_FINISHES[key];
      if (popupBadge && popupStat) {
        if (pop) {
          popupBadge.hidden = false;
          popupStat.hidden = false;
          popupStat.textContent = 'Used in ' + pop.pct + '% of orders';
        } else {
          popupBadge.hidden = true;
          popupStat.hidden = true;
        }
      }

      /* 2026-05-06 v3 — match doors PDP behavior exactly:
         - Mobile: 1:1 square image (150Ã—150), compact popup
         - Position ABOVE swatch by default (matching doors)
         - Use #efmWrap as reference (full configurator) — same scope as doors
           uses `root`. Prior `gridEl.parentElement` was a tight container right
           above the swatches, so popup couldn't fit above and always
           fell back to BELOW (reported 2026-05-06).
         - Live-measured offsetHeight (badge / stat rows toggle height). */
      var isMobile = window.innerWidth <= 599;
      swatchPopup.classList.toggle('ef-cfg-mantel-swatch-popup--compact', isMobile);
      swatchPopup.style.visibility = 'hidden';
      swatchPopup.classList.add('is-visible');
      var popupW = swatchPopup.offsetWidth || (isMobile ? 150 : 180);
      var popupH = swatchPopup.offsetHeight || (isMobile ? 200 : 250);
      var rect = btn.getBoundingClientRect();
      var wrapEl = document.getElementById('efmWrap') || gridEl.parentElement;
      var wrapRect = wrapEl.getBoundingClientRect();
      var left = rect.left - wrapRect.left + rect.width / 2 - popupW / 2;
      left = Math.max(8, Math.min(left, wrapRect.width - popupW - 8));
      var top = rect.top - wrapRect.top - popupH - 10;
      /* Doors-style fallback — if popup would clip above the wrap, flip
         it to below the swatch instead. */
      if (top < 8) top = rect.bottom - wrapRect.top + 10;

      /* Re-parent popup to #efmWrap so absolute positioning is relative to the
         configurator root (matches doors). Idempotent — no-op if already there. */
      if (swatchPopup.parentElement !== wrapEl) {
        wrapEl.appendChild(swatchPopup);
      }

      swatchPopup.style.left = left + 'px';
      swatchPopup.style.top = top + 'px';
      swatchPopup.style.bottom = 'auto';
      swatchPopup.style.visibility = '';
    }

    function hideSwatchPopup() {
      swatchPopup.classList.remove('is-visible');
    }
    /* Expose globally so outer goToStep can hide popup on step transitions
       (popup persisted onto step 4 review per user report 2026-05-06). */
    window.efmHideSwatchPopup = hideSwatchPopup;

    /* 2026-05-06 — Auto-close popup when user scrolls more than 60px. Without
       this, popup stays anchored to the swatch as the page scrolls, eventually
       overlapping the sticky cart bar (bottom) and sticky header (top) which
       feels broken on mobile. Threshold avoids flicker on tiny rubber-band
       scrolls. */
    var _popupScrollY = null;
    window.addEventListener('scroll', function() {
      if (!swatchPopup.classList.contains('is-visible')) { _popupScrollY = null; return; }
      if (_popupScrollY === null) { _popupScrollY = window.scrollY; return; }
      if (Math.abs(window.scrollY - _popupScrollY) > 60) {
        hideSwatchPopup();
        _popupScrollY = null;
      }
    }, { passive: true });
    /* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
       EF MANTEL FINISH PREVIEW — swap main gallery image on swatch click.
       Defensive — wrapped in try/catch so absence of gallery never breaks configurator.
       â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
    function efmGalleryFirstImg() {
      /* 2026-05-11 — switched from :first-child (unreliable after Swiper DOM
         shuffling) to [data-media-index="0"] which is set in Liquid and stable. */
      try {
        return document.querySelector(
          '#efGallerySwiper .swiper-slide[data-media-index="0"] picture img, ' +
          '#efGallerySwiper .swiper-slide[data-media-index="0"] img, ' +
          '#efGallerySwiper .swiper-slide:first-child picture img, ' +
          '#efGallerySwiper .swiper-slide:first-child img'
        );
      } catch(e) { return null; }
    }
    function efmGalleryFirstSlide() {
      try {
        return document.querySelector(
          '#efGallerySwiper .swiper-slide[data-media-index="0"], ' +
          '#efGallerySwiper .swiper-slide:first-child'
        );
      } catch(e) { return null; }
    }
    function efmSwapMainImage(previewUrl) {
      var img = efmGalleryFirstImg();
      if (!img || !previewUrl) return;
      if (!img.dataset.efOriginalSrc) {
        img.dataset.efOriginalSrc = img.getAttribute('src') || '';
        img.dataset.efOriginalSrcset = img.getAttribute('srcset') || '';
      }
      /* Strip srcset entirely — single-URL srcset can be ignored by browser;
         removing it forces browser to honor src. */
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      /* If wrapped in <picture> with <source> elements, hide those so they
         don't outrank img.src. */
      var slide = efmGalleryFirstSlide();
      if (slide) {
        slide.querySelectorAll('picture source').forEach(function(s){ s.setAttribute('data-ef-hidden', '1'); s.setAttribute('srcset', previewUrl); });
      }
      img.setAttribute('src', previewUrl);
      /* Navigate Swiper to slide 0 so user sees the swapped image even if they
         were viewing slide 2/3/etc when clicking a finish. */
      try {
        if (window.EFGallery && window.EFGallery.main && typeof window.EFGallery.main.slideTo === 'function') {
          window.EFGallery.main.slideTo(0, 250);
        }
      } catch(e) {}
    }
    function efmRestoreMainImage() {
      var img = efmGalleryFirstImg();
      if (!img || !img.dataset.efOriginalSrc) return;
      img.setAttribute('src', img.dataset.efOriginalSrc);
      if (img.dataset.efOriginalSrcset) img.setAttribute('srcset', img.dataset.efOriginalSrcset);
      else img.removeAttribute('srcset');
    }



    /* Mobile inline live finish preview — cross-fade the big shelf-in-this-finish image
       right at the swatches (the gallery swap is off-screen on phones). Stateless: reads
       the .is-shown class to pick the A/B layer. 2026-06-25. */
    function efmLivePreview(src, name) {
      var lp = document.getElementById('efmFinishLivePreview');
      if (!lp) return;
      if (!src) { lp.hidden = true; return; }
      var imgA = document.getElementById('efmFinishLiveImgA');
      var imgB = document.getElementById('efmFinishLiveImgB');
      var tag = document.getElementById('efmFinishLiveTag');
      lp.hidden = false;
      var aShown = imgA.classList.contains('is-shown');
      var next = aShown ? imgB : imgA, cur = aShown ? imgA : imgB;
      function reveal() { next.classList.add('is-shown'); cur.classList.remove('is-shown'); }
      if (next.getAttribute('src') === src) { reveal(); }
      else { next.onload = reveal; next.src = src; }
      if (tag) tag.textContent = name || '';
    }

    /* Re-resolve + re-apply the gallery preview after a WOOD change (Transitional
       wood+metal product) — picks the wood|finish combo render when available. */
    window.__efmRefreshPreview = function() {
      try {
        var cd = _efmCurColorData;
        var pv = efmPreviewOverride(cd && cd.name) || (cd && cd.previewImg);
        if (pv) {
          efmSwapMainImage(pv);
          efmLivePreview(pv, (cd && cd.name) || (state.wood_color && state.wood_color.name) || '');
        }
      } catch(e) {}
    };

    function selectSwatch(btn, colorData) {
      /* Toggle off — second click on already-selected swatch deselects.
         Same UX as doors configurator. */
      if (btn.getAttribute('aria-checked') === 'true') {
        btn.setAttribute('aria-checked', 'false');
        btn.setAttribute('aria-pressed', 'false');
        state.color = null;
        _efmCurColorData = null;
        if (window.EFMantel3D) { try { window.EFMantel3D.setFinish('#1c1c1c', 'Standard', 'Matte Black'); } catch (e) {} }
        var prevHide = document.getElementById('efmFinishPreview');
        if (prevHide) prevHide.classList.remove('is-visible');
        try { var lpHide = document.getElementById('efmFinishLivePreview'); if (lpHide) lpHide.hidden = true; } catch(e) {}
        try { hideSwatchPopup(); } catch(e) {}
        try { updateTotal(); } catch(e) {}
        try { var wpv = efmPreviewOverride(null); if (wpv) efmSwapMainImage(wpv); else efmRestoreMainImage(); } catch(e) {}
        return;
      }

      gridEl.querySelectorAll('.efm-swatch').forEach(function(s) {
        s.setAttribute('aria-checked', 'false');
        s.setAttribute('aria-pressed', 'false');
      });
      btn.setAttribute('aria-checked', 'true');
      btn.setAttribute('aria-pressed', 'true');

      state.color = { name: colorData.name, label: colorData.name, surcharge: colorData.surcharge, variantId: colorData.variantId || null };

      /* Paint the 3D preview the chosen finish (no-op if 3D didn't init). */
      if (window.EFMantel3D) { try { window.EFMantel3D.setFinish(colorData.hex, colorData.tier, colorData.name); } catch (e) {} }

      /* Update finish preview */
      var prev = document.getElementById('efmFinishPreview');
      prev.classList.add('is-visible');
      document.getElementById('efmFinishPreviewSwatch').style.backgroundImage = colorData.img ? 'url(' + colorData.img.replace(/ /g, '%20') + ')' : '';
      document.getElementById('efmFinishPreviewName').textContent = colorData.name;
      document.getElementById('efmFinishPreviewPrice').textContent = colorData.surcharge ? fmt(colorData.surcharge) : 'Included';

      /* EF FINISH PREVIEW — swap gallery main image. Per-product override map
         (EF_MANTEL_FINISH_PREVIEWS, incl. wood|finish combo keys) beats the
         palette-level previewImg. */
      _efmCurColorData = colorData;
      var _efmPv = efmPreviewOverride(colorData.name) || colorData.previewImg;
      try { if (_efmPv) efmSwapMainImage(_efmPv); else efmRestoreMainImage(); } catch(e) {}
      /* Mobile inline live preview — show the shelf in this finish right at the swatches */
      try { efmLivePreview(_efmPv, colorData.name); } catch(e) {}

      updateTotal();

      /* Show hover popup after layout settles — mobile click doesn't fire
         mouseenter, and price-section height shifts swatch position when
         surcharge tiers (Premium/Steel) are picked. */
      requestAnimationFrame(function() {
        try { showSwatchPopup(btn, colorData); } catch(e) {}
      });
    }

    /* Tier-specific callouts (Wood Grain explains why $1500 — premium handcrafted). */
    var EFM_TIER_CALLOUTS = {
      'Wood Grain': {
        title: 'Hand-Applied by a Blacksmith',
        desc: 'Each Wood Grain finish is hand-forged by a master blacksmith using a proprietary technique. No two pieces are identical — yours is one-of-a-kind.'
      },
      'Handcrafted': {
        title: 'Artisan Handmade',
        desc: 'Hand-finished by skilled craftsmen — every piece is unique, signed, and signature-numbered.'
      },
      'Boutique': {
        title: 'Limited-Run Boutique Finish',
        desc: 'Small-batch finish in limited quantities. Premium materials and careful application give each mantel a distinctive character.'
      }
    };
    var calloutEl = document.getElementById('efmTierCallout');
    var calloutTitleEl = document.getElementById('efmTierCalloutTitle');
    var calloutDescEl = document.getElementById('efmTierCalloutDesc');

    function showSwatchesForTier(tierKey) {
      /* Show/hide tier callout */
      if (calloutEl) {
        var co = EFM_TIER_CALLOUTS[tierKey];
        if (co) {
          calloutEl.hidden = false;
          if (calloutTitleEl) calloutTitleEl.textContent = co.title;
          if (calloutDescEl) calloutDescEl.textContent = co.desc;
        } else {
          calloutEl.hidden = true;
        }
      }
      gridEl.innerHTML = '';
      DATA.colors.forEach(function(c) {
        if (c.tier !== tierKey) return;

        var btn = document.createElement('button');
        btn.className = 'efm-swatch';
        btn.setAttribute('type', 'button');
        btn.setAttribute('aria-checked', state.color && state.color.name === c.name ? 'true' : 'false');
        btn.setAttribute('aria-pressed', state.color && state.color.name === c.name ? 'true' : 'false');
        btn.setAttribute('aria-label', c.name + (c.surcharge ? ', plus ' + fmt(c.surcharge) : ', included'));
        btn.setAttribute('tabindex', '0');

        var circle = document.createElement('span');
        circle.className = 'efm-swatch__circle';
        if (c.img) circle.style.backgroundImage = 'url(' + c.img.replace(/ /g, '%20') + ')';
        else circle.style.background = c.hex || '#333';

        var tooltip = document.createElement('span');
        tooltip.className = 'efm-swatch__tooltip';
        tooltip.innerHTML = c.name + '<br>' + (c.surcharge ? fmt(c.surcharge) : 'Included');

        btn.appendChild(circle);
        btn.appendChild(tooltip);

        btn.addEventListener('click', function() { selectSwatch(btn, c); });
        /* Hover events only fire reliably on hover-capable devices (desktop with mouse).
           On touch, iOS simulates mouseenter on tap and mouseleave on lift — the latter
           hides the popup we just showed via selectSwatch. Gate by (hover: hover). */
        btn.addEventListener('mouseenter', function() {
          if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
            showSwatchPopup(btn, c);
          }
        });
        btn.addEventListener('mouseleave', function() {
          if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
            hideSwatchPopup();
          }
        });

        gridEl.appendChild(btn);
      });
    }

    showSwatchesForTier(activeTab);

    var next2Nav = document.getElementById('efmNext2');
    if (next2Nav) {
      next2Nav.addEventListener('click', function() {
        /* Validate wood_color first if shown — flash wood section if missing */
        if (CFG.showWoodColor && !state.wood_color) {
          var ws = document.getElementById('efmWoodSection');
          if (ws) {
            ws.style.outline = '2px solid #C0533A';
            ws.style.outlineOffset = '4px';
            ws.style.borderRadius = '8px';
            ws.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(function() {
              ws.style.outline = '';
              ws.style.outlineOffset = '';
            }, 4000);
          }
          return;
        }
        if (state.color) {
          goToStep(3);
        } else {
          /* Highlight swatch grid */
          var grid = document.getElementById('efmSwatchGrid');
          if (grid) {
            grid.style.outline = '2px solid #C0533A';
            grid.style.outlineOffset = '4px';
            grid.style.borderRadius = '8px';
            grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            var errId = 'efmErr_color';
            if (!document.getElementById(errId)) {
              var err = document.createElement('div');
              err.id = errId;
              err.style.cssText = 'color:#C0533A;font-size:12px;margin-top:8px;font-weight:500;';
              err.textContent = 'Please select a finish color';
              grid.parentNode.appendChild(err);
            }
            setTimeout(function() {
              grid.style.outline = '';
              grid.style.outlineOffset = '';
              var e = document.getElementById(errId);
              if (e) e.remove();
            }, 4000);
          }
        }
      });
    }
  })();

  /* ================================================================
     FINISH SAMPLES — multi-select, $10 each, ATC
     Backend: requires Shopify product "Mantel Finish Sample" at $10.
     Replace MANTEL_SAMPLE_VARIANT_ID below with the real variant ID.
     ================================================================ */
  (function buildSamples() {
    var MANTEL_SAMPLE_VARIANT_ID = '42380268601426'; /* Steel Mantel Finish Sample — handle: steel-mantel-finish-sample */
    var SAMPLE_PRICE = 10;

    var grid = document.getElementById('efmSamplesGrid');
    if (!grid || !window.DATA && !DATA) return;
    var data = (typeof DATA !== 'undefined' && DATA.colors) ? DATA.colors : [];
    if (!data.length) return;

    var selected = {}; /* { name: { name, hex, img } } */

    /* Build grid (hide premium-only finishes? include all for now) */
    grid.innerHTML = data.map(function(c) {
      var bgStyle = c.img
        ? 'background-image:url(' + c.img.replace(/ /g, '%20') + ');background-color:' + (c.hex || '#888') + ';'
        : 'background-color:' + (c.hex || '#888') + ';';
      return '<button type="button" class="efm-samples-card" data-name="' + (c.name || '').replace(/"/g, '&quot;') + '" data-hex="' + (c.hex || '') + '" aria-pressed="false">' +
        '<span class="efm-samples-card__swatch" style="' + bgStyle + '"></span>' +
        '<span class="efm-samples-card__name">' + c.name + '</span>' +
      '</button>';
    }).join('');

    var countEl = document.getElementById('efmSamplesCount');
    var totalEl = document.getElementById('efmSamplesTotal');
    var atcBtn = document.getElementById('efmSamplesAtc');

    function updateBar() {
      var n = Object.keys(selected).length;
      countEl.textContent = n + (n === 1 ? ' selected' : ' selected');
      totalEl.textContent = '$' + (n * SAMPLE_PRICE).toLocaleString('en-US');
      atcBtn.disabled = n === 0;
    }

    grid.addEventListener('click', function(e) {
      var card = e.target.closest('.efm-samples-card');
      if (!card) return;
      var name = card.getAttribute('data-name');
      if (selected[name]) {
        delete selected[name];
        card.classList.remove('is-selected');
        card.setAttribute('aria-pressed', 'false');
      } else {
        /* Look up the swatch image so we can pass it as a hidden line-item
           property — cart drawer reads _swatch_url to render the actual color. */
        var swatchUrl = '';
        for (var i = 0; i < data.length; i++) {
          if (data[i].name === name) { swatchUrl = data[i].img || ''; break; }
        }
        selected[name] = {
          name: name,
          hex: card.getAttribute('data-hex'),
          img: swatchUrl
        };
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
      }
      updateBar();
    });

    atcBtn.addEventListener('click', function() {
      var names = Object.keys(selected);
      if (!names.length) return;

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';

      /* Each sample = its own line item with finish-name property so the order
         shows "Finish: Bronze Burst" etc. for fulfillment to ship the right swatch. */
      var sampleConfigId = 'sample-' + Date.now().toString(36);
      var items = names.map(function(n) {
        var props = {
          'Finish': n,
          '_sample_set_id': sampleConfigId
        };
        var meta = selected[n] || {};
        /* Property names match what ef-cart-drawer.js expects (line 113-114).
           Always pass hex as fallback — texture/steel tier finishes carry only
           hex, not img. Drawer prefers _finish_image, falls back to _finish_color. */
        if (meta.img) props._finish_image = meta.img;
        if (meta.hex) props._finish_color = meta.hex;
        return {
          id: parseInt(MANTEL_SAMPLE_VARIANT_ID),
          quantity: 1,
          properties: props
        };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { if (!r.ok) throw new Error('cart error'); return r.json(); })
      .then(function() {
        atcBtn.style.background = '#8A6A43';
        atcBtn.innerHTML = 'Added âœ“';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        /* Open EF custom cart drawer — never Prestige's <cart-drawer>, fonts differ */
        if (window.EFCartDrawer && typeof window.EFCartDrawer.open === 'function') {
          window.EFCartDrawer.open();
        }
        setTimeout(function() {
          atcBtn.disabled = true;
          atcBtn.style.background = '';
          atcBtn.innerHTML = 'Add Samples <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>';
          /* Reset selection */
          selected = {};
          grid.querySelectorAll('.efm-samples-card.is-selected').forEach(function(c) {
            c.classList.remove('is-selected');
            c.setAttribute('aria-pressed', 'false');
          });
          updateBar();
        }, 1200);
      })
      .catch(function() {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Error — try again';
        setTimeout(function() {
          atcBtn.innerHTML = 'Add Samples <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>';
        }, 2000);
      });
    });

    updateBar();
  })();

  /* ================================================================
     STEP 3 — Add-ons
     ================================================================ */
  (function buildAddons() {
    var container = document.getElementById('efmAddons');
    var groups = ['brackets', 'banding', 'bluetooth'];
    var html = '';

    groups.forEach(function(key) {
      var group = DATA.addons[key];
      html += '<div class="ef-cfg-mantel-addon-group">';
      html += '<div class="ef-cfg-mantel-addon-group__title">' + group.title + '<span class="efm-group-label__pick">Pick 1</span></div>';
      html += '<div class="ef-cfg-mantel-addon-cards" role="radiogroup" aria-label="' + group.title + '">';
      group.options.forEach(function(opt, idx) {
        var activeClass = idx === 0 ? ' is-active' : '';
        var isSkip = opt.name === 'No Thank You';
        /* "No Thank You" — inline SVG (ring with diagonal slash, universal "none/skip"
           glyph). Replaces stale EFLOGO.jpg from old Avis CDN. 2026-05-03. */
        var imgHtml;
        if (isSkip) {
          imgHtml = '<div class="ef-cfg-mantel-addon-card__img ef-cfg-mantel-addon-card__img--skip" aria-hidden="true">' +
            '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
              '<circle cx="32" cy="32" r="22" stroke="currentColor" stroke-width="2.2" opacity="0.55"/>' +
              '<line x1="17" y1="47" x2="47" y2="17" stroke="currentColor" stroke-width="2.2" opacity="0.55" stroke-linecap="round"/>' +
            '</svg>' +
          '</div>';
        } else {
          imgHtml = opt.img
            ? '<img class="ef-cfg-mantel-addon-card__img" src="' + opt.img + '" alt="' + opt.name + '" loading="lazy">'
            : '';
        }
        html += '<div class="ef-cfg-mantel-addon-card' + activeClass + '" data-addon-group="' + key + '" data-addon-idx="' + idx + '">' +
          imgHtml +
          '<div class="ef-cfg-mantel-addon-card__name">' + opt.name + '</div>' +
          '<div class="ef-cfg-mantel-addon-card__price">' + fmt(opt.surcharge) + '</div>' +
        '</div>';
      });
      html += '</div></div>';
    });

    container.innerHTML = html;

    $$('.ef-cfg-mantel-addon-card', container).forEach(function(card) {
      card.addEventListener('click', function() {
        var group = card.getAttribute('data-addon-group');
        var idx = parseInt(card.getAttribute('data-addon-idx'));

        /* Deselect siblings */
        $$('.ef-cfg-mantel-addon-card[data-addon-group="' + group + '"]', container).forEach(function(c) {
          c.classList.remove('is-active');
        });
        card.classList.add('is-active');

        var opt = DATA.addons[group].options[idx];
        state[group] = { name: opt.name, surcharge: opt.surcharge, variantId: opt.variantId || null, label: opt.name };
        updateTotal();
      });
    });

    var next3Btn = document.getElementById('efmNext3');
    if (next3Btn) next3Btn.addEventListener('click', function() { goToStep(4); });
  })();

  /* ================================================================
     STEP 4 — Summary
     ================================================================ */
  function buildSummary() {
    var container = document.getElementById('efmReviewTable');
    if (!container) return;

    var rows = [
      { label: 'Shelf Length', value: state.length ? state.length.inch + '"' : '—', surcharge: state.length ? state.length.surcharge : 0, step: 1 },
      { label: 'Shelf Height', value: state.height ? state.height.label : '—', surcharge: state.height ? state.height.surcharge : 0, step: 1 },
      { label: 'Shelf Depth', value: state.depth ? state.depth.label : '—', surcharge: state.depth ? state.depth.surcharge : 0, step: 1 }
    ];
    if (CFG.showWoodColor) {
      rows.push({ label: 'Wood Color', value: state.wood_color ? state.wood_color.name : '—', surcharge: 0, step: 2 });
    }
    rows.push(
      { label: 'Color / Finish', value: state.color ? state.color.name : '—', surcharge: state.color ? state.color.surcharge : 0, step: 2 },
      { label: 'Decorative Brackets', value: state.brackets.name, surcharge: state.brackets.surcharge, step: 3 },
      { label: 'Decorative Banding', value: state.banding.name, surcharge: state.banding.surcharge, step: 3 },
      { label: 'Bluetooth & Lights', value: state.bluetooth.name, surcharge: state.bluetooth.surcharge, step: 3 }
    );

    var html = '';
    rows.forEach(function(r) {
      var priceHtml = r.surcharge > 0 ? '<span class="ef-cfg-review-item__price">+$' + r.surcharge.toLocaleString() + '</span>' : '';
      /* Bronze sentence-case "Edit" text link + per-row aria-label (mirrors doors
         refactor 2026-05-03 — kills the "Edit Edit Edit" SR experience and
         drops the chip styling). */
      var ariaLabel = 'Edit ' + r.label.toLowerCase();
      html += '<div class="ef-cfg-review-item">' +
        '<span class="ef-cfg-review-item__label">' + r.label + '</span>' +
        '<span class="ef-cfg-review-item__value">' + r.value + '</span>' +
        priceHtml +
        '<a href="#" class="ef-cfg-review-item__edit" data-edit-step="' + r.step + '" aria-label="' + ariaLabel + '">Edit</a>' +
      '</div>';
    });

    container.innerHTML = html;

    /* Wire up Edit links via delegation (replaces inline onclick to support
       data-edit-step pattern + aria-label). */
    container.onclick = function (e) {
      var link = e.target.closest('[data-edit-step]');
      if (!link) return;
      e.preventDefault();
      var stepNum = parseInt(link.getAttribute('data-edit-step'), 10);
      if (typeof goToStep === 'function') goToStep(stepNum);
    };
  }

  /* ================================================================
     ADD TO CART — same pattern as doors
     ================================================================ */
  var efmSubmitBtn = document.getElementById('efmSubmit');
  if (efmSubmitBtn) efmSubmitBtn.addEventListener('click', function() {
    var btn = this;
    if (btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    /* Build properties from selections — include surcharge amounts for cart display */
    var props = {};
    if (state.length) {
      props['Shelf Length'] = state.length.inch + '"';
      if (state.length.surcharge > 0) props['_surcharge_length'] = '+$' + state.length.surcharge.toLocaleString();
    }
    if (state.height) {
      props['Shelf Height'] = state.height.label;
      if (state.height.surcharge > 0) props['_surcharge_height'] = '+$' + state.height.surcharge.toLocaleString();
    }
    if (state.depth) {
      props['Shelf Depth'] = state.depth.label;
      if (state.depth.surcharge > 0) props['_surcharge_depth'] = '+$' + state.depth.surcharge.toLocaleString();
    }
    if (state.color) {
      props['Color'] = state.color.name;
      if (state.color.surcharge > 0) props['_surcharge_color'] = '+$' + state.color.surcharge.toLocaleString();
    }
    if (state.brackets.name !== 'No Thank You') {
      props['Decorative Brackets'] = state.brackets.name;
      if (state.brackets.surcharge > 0) props['_surcharge_brackets'] = '+$' + state.brackets.surcharge.toLocaleString();
    }
    if (state.banding.name !== 'No Thank You') {
      props['Decorative Banding'] = state.banding.name;
      if (state.banding.surcharge > 0) props['_surcharge_banding'] = '+$' + state.banding.surcharge.toLocaleString();
    }
    if (state.bluetooth.name !== 'No Thank You') {
      props['Bluetooth & Lights'] = state.bluetooth.name;
      if (state.bluetooth.surcharge > 0) props['_surcharge_bluetooth'] = '+$' + state.bluetooth.surcharge.toLocaleString();
    }

    var notesEl = document.getElementById('efmNotes');
    if (notesEl && notesEl.value.trim()) props['_Notes'] = notesEl.value.trim();

    /* Configured price for cart display */
    var basePrice = (window.EF_MANTELS_DATA.basePrice / 100);
    var total = basePrice + calcTotal();
    props['_Configured Price'] = '$' + fmtPrice(total);
    var configId = Date.now().toString(36);
    props['_config_id'] = configId;

    var variantId = window.EF_MANTELS_DATA.variantId;
    var prodTitle = window.EF_MANTELS_DATA.prodTitle;

    /* Build items array — main product + surcharge variant line items */
    var items = [];

    /* 1) Main product item */
    items.push({
      id: parseInt(variantId),
      quantity: 1,
      properties: props
    });

    /* 2) Surcharge variant items — each gets its own line item */
    if (state.length && state.length.variantId && state.length.surcharge > 0) {
      items.push({
        id: parseInt(state.length.variantId),
        quantity: 1,
        properties: {
          '_parent_product': prodTitle,
          '_option_type': 'Shelf Length',
          '_config_id': configId
        }
      });
    }
    if (state.height && state.height.variantId && state.height.surcharge > 0) {
      items.push({
        id: parseInt(state.height.variantId),
        quantity: 1,
        properties: {
          '_parent_product': prodTitle,
          '_option_type': 'Shelf Height',
          '_config_id': configId
        }
      });
    }
    if (state.depth && state.depth.variantId && state.depth.surcharge > 0) {
      items.push({
        id: parseInt(state.depth.variantId),
        quantity: 1,
        properties: {
          '_parent_product': prodTitle,
          '_option_type': 'Shelf Depth',
          '_config_id': configId
        }
      });
    }
    if (state.color && state.color.variantId && state.color.surcharge > 0) {
      items.push({
        id: parseInt(state.color.variantId),
        quantity: 1,
        properties: {
          '_parent_product': prodTitle,
          '_option_type': 'Color / Finish',
          '_config_id': configId
        }
      });
    }
    if (state.brackets.variantId && state.brackets.surcharge > 0) {
      items.push({
        id: parseInt(state.brackets.variantId),
        quantity: 1,
        properties: {
          '_parent_product': prodTitle,
          '_option_type': 'Decorative Brackets',
          '_config_id': configId
        }
      });
    }
    if (state.banding.variantId && state.banding.surcharge > 0) {
      items.push({
        id: parseInt(state.banding.variantId),
        quantity: 1,
        properties: {
          '_parent_product': prodTitle,
          '_option_type': 'Decorative Banding',
          '_config_id': configId
        }
      });
    }
    if (state.bluetooth.variantId && state.bluetooth.surcharge > 0) {
      items.push({
        id: parseInt(state.bluetooth.variantId),
        quantity: 1,
        properties: {
          '_parent_product': prodTitle,
          '_option_type': 'Bluetooth & Lights',
          '_config_id': configId
        }
      });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart error ' + res.status);
      return res.json();
    })
    .then(function() {
      /* Show success on button — NO success screen */
      btn.textContent = 'Added to Cart \u2713';
      btn.style.background = '#8A6A43';

      setTimeout(function() {
        /* Open EF custom cart drawer (same pattern as doors configurator).
           NEVER use Prestige's <cart-drawer> here \u2014 it fires in parallel
           with EF drawer and creates the "2 carts" behaviour. */
        if (window.EFCartDrawer && typeof window.EFCartDrawer.open === 'function') {
          window.EFCartDrawer.open();
        } else {
          window.location.href = '/cart';
        }

        /* Reset button after 2s */
        setTimeout(function() {
          btn.disabled = false;
          btn.style.background = '';
          btn.textContent = 'Add to Cart \u2014 $' + fmtPrice(total);
        }, 2000);
      }, 800);
    })
    .catch(function(err) {
      console.error('ATC error:', err);
      btn.disabled = false;
      btn.style.background = '';
      btn.textContent = 'Error \u2014 Try Again';
      setTimeout(function() {
        btn.textContent = 'Add to Cart \u2014 $' + fmtPrice(total);
      }, 2000);
    });

    /* showSuccess removed — doors pattern uses inline button state instead */
  });

  /* ================================================================
     NATIVE DYNAMIC CHECKOUT BUTTON — Buy with shop / PayPal / Apple Pay
     ================================================================
     Same pattern as doors PDP (2026-05-03). Native {{ form | payment_button }}
     renders a wallet button auto-detected from the buyer's browser. We
     capture the click in capture phase BEFORE Shopify's wallet popup opens,
     silently ATC base + surcharges to honor the configured cart total, then
     hard-redirect to /checkout where the SAME wallet appears as accelerated
     checkout (Shop Pay token if logged in, otherwise standard checkout). */
  function efmBuildItemsForWallet() {
    /* Mirror the ATC handler payload (above) so the order in admin shows every
       customer selection. Keep this in sync with the efmSubmit handler. */
    var props = {};
    if (state.length) {
      props['Shelf Length'] = state.length.inch + '"';
      if (state.length.surcharge > 0) props['_surcharge_length'] = '+$' + state.length.surcharge.toLocaleString();
    }
    if (state.height) {
      props['Shelf Height'] = state.height.label;
      if (state.height.surcharge > 0) props['_surcharge_height'] = '+$' + state.height.surcharge.toLocaleString();
    }
    if (state.depth) {
      props['Shelf Depth'] = state.depth.label;
      if (state.depth.surcharge > 0) props['_surcharge_depth'] = '+$' + state.depth.surcharge.toLocaleString();
    }
    if (state.color) {
      props['Color'] = state.color.name;
      if (state.color.surcharge > 0) props['_surcharge_color'] = '+$' + state.color.surcharge.toLocaleString();
    }
    if (state.brackets && state.brackets.name && state.brackets.name !== 'No Thank You') {
      props['Decorative Brackets'] = state.brackets.name;
      if (state.brackets.surcharge > 0) props['_surcharge_brackets'] = '+$' + state.brackets.surcharge.toLocaleString();
    }
    if (state.banding && state.banding.name && state.banding.name !== 'No Thank You') {
      props['Decorative Banding'] = state.banding.name;
      if (state.banding.surcharge > 0) props['_surcharge_banding'] = '+$' + state.banding.surcharge.toLocaleString();
    }
    if (state.bluetooth && state.bluetooth.name && state.bluetooth.name !== 'No Thank You') {
      props['Bluetooth & Lights'] = state.bluetooth.name;
      if (state.bluetooth.surcharge > 0) props['_surcharge_bluetooth'] = '+$' + state.bluetooth.surcharge.toLocaleString();
    }
    var notesEl = document.getElementById('efmNotes');
    if (notesEl && notesEl.value.trim()) props['_Notes'] = notesEl.value.trim();

    var basePrice = (window.EF_MANTELS_DATA.basePrice / 100);
    var total = basePrice + calcTotal();
    props['_Configured Price'] = '$' + fmtPrice(total);
    var configId = Date.now().toString(36);
    props['_config_id'] = configId;

    var variantId = window.EF_MANTELS_DATA.variantId;
    var prodTitle = window.EF_MANTELS_DATA.prodTitle;

    var items = [{ id: parseInt(variantId), quantity: 1, properties: props }];

    function pushSurcharge(s, optionType) {
      if (s && s.variantId && s.surcharge > 0) {
        items.push({
          id: parseInt(s.variantId),
          quantity: 1,
          properties: {
            '_parent_product': prodTitle,
            '_option_type': optionType,
            '_config_id': configId
          }
        });
      }
    }
    pushSurcharge(state.length, 'Shelf Length');
    pushSurcharge(state.height, 'Shelf Height');
    pushSurcharge(state.depth, 'Shelf Depth');
    pushSurcharge(state.color, 'Color / Finish');
    pushSurcharge(state.brackets, 'Decorative Brackets');
    pushSurcharge(state.banding, 'Decorative Banding');
    pushSurcharge(state.bluetooth, 'Bluetooth & Lights');

    return items;
  }

  function efmWalletCheckoutHandler(triggerEl, e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
    if (triggerEl && !triggerEl.dataset.walletBusy) {
      triggerEl.dataset.walletBusy = '1';
      triggerEl.style.pointerEvents = 'none';
      triggerEl.style.opacity = '0.7';
    }
    var items = efmBuildItemsForWallet();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || 'Cart error ' + r.status); });
      return r.json();
    })
    .then(function () { window.location.href = '/checkout'; })
    .catch(function (err) {
      console.error('[Mantel wallet checkout] Cart error:', err);
      if (triggerEl) {
        triggerEl.style.pointerEvents = '';
        triggerEl.style.opacity = '';
        delete triggerEl.dataset.walletBusy;
      }
      alert('Could not start checkout: ' + err.message + '\n\nPlease use Add to Cart instead.');
    });
  }

  /* Capture-phase listener on the native shop-pay-button container */
  var efmShopPayWrap = document.getElementById('efmShopPayWrap');
  if (efmShopPayWrap) {
    efmShopPayWrap.addEventListener('click', function (e) {
      var inner = e.target.closest('button, [role="button"], a');
      efmWalletCheckoutHandler(inner || efmShopPayWrap, e);
    }, true);
  }

  /* "More payment options" — same handler, no wallet branding */
  var efmMorePayBtn = document.getElementById('efmMorePay');
  if (efmMorePayBtn) {
    efmMorePayBtn.addEventListener('click', function (e) {
      efmWalletCheckoutHandler(efmMorePayBtn, e);
    });
  }

  /* â”€â”€ Init â”€â”€ */
  updateProgress();
  updateTotal();

  /* ================================================================
     GALLERY — Thumbnail Click â†’ Crossfade
     ================================================================ */
  document.querySelectorAll('.ef-cfg-mantel-thumb').forEach(function(thumb, idx) {
    thumb.addEventListener('click', function() {
      efmCurrentIdx = idx;
      efmRenderMedia(idx);
      // Highlight active
      document.querySelectorAll('.ef-cfg-mantel-thumb').forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      // Update counter
      var counter = document.querySelector('.ef-cfg-mantel-counter');
      if (counter) counter.textContent = (idx + 1) + ' / ' + document.querySelectorAll('.ef-cfg-mantel-thumb').length;
      // Scroll thumb into view
      var rail = document.getElementById('efmThumbRail');
      if (rail) {
        var railRect = rail.getBoundingClientRect();
        var thumbRect = thumb.getBoundingClientRect();
        if (thumbRect.left < railRect.left || thumbRect.right > railRect.right) {
          thumb.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        }
      }
    });
  });

  /* Thumbnail rail arrow buttons */
  (function() {
    var rail = document.getElementById('efmThumbRail');
    var prevBtn = document.getElementById('efmThumbPrev');
    var nextBtn = document.getElementById('efmThumbNext');
    if (prevBtn && rail) {
      prevBtn.addEventListener('click', function() {
        rail.scrollBy({ left: -rail.offsetWidth * 0.6, behavior: 'smooth' });
      });
    }
    if (nextBtn && rail) {
      nextBtn.addEventListener('click', function() {
        rail.scrollBy({ left: rail.offsetWidth * 0.6, behavior: 'smooth' });
      });
    }
  })();

  /* ================================================================
     GALLERY — Lens Zoom
     ================================================================ */
  (function() {
    var galleryMain = document.querySelector('.ef-cfg-mantel-gallery__main');
    var lens = document.getElementById('efmLens');
    if (!galleryMain || !lens) return;
    var zoom = 2.5;
    galleryMain.addEventListener('mousemove', function(e) {
      var mainImg = document.getElementById('efmMainImage');
      if (!mainImg) { lens.style.display = 'none'; return; }
      var rect = galleryMain.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      lens.style.left = (x - 90) + 'px';
      lens.style.top = (y - 90) + 'px';
      lens.style.backgroundImage = 'url(' + mainImg.src + ')';
      lens.style.backgroundSize = (rect.width * zoom) + 'px ' + (rect.height * zoom) + 'px';
      lens.style.backgroundPosition = -(x / rect.width * rect.width * zoom - 90) + 'px ' + -(y / rect.height * rect.height * zoom - 90) + 'px';
    });
    galleryMain.addEventListener('mouseleave', function() { lens.style.display = 'none'; });
    galleryMain.addEventListener('mouseenter', function() {
      if (window.innerWidth > 1024 && document.getElementById('efmMainImage')) lens.style.display = 'block';
    });
  })();

})();

/* â”€â”€ Gallery prev/next navigation (supports images + video) â”€â”€ */
var efmAllMedia = (window.EF_MANTELS_DATA && window.EF_MANTELS_DATA.media) || [];
var efmCurrentIdx = (window.EF_MANTELS_DATA && window.EF_MANTELS_DATA.startIndex) || 0;

/* Preload all image media so subsequent switches are instant (browser cache hit). */
(function efmPreload() {
  efmAllMedia.forEach(function(m) {
    if (m.type === 'image') {
      var pre = new Image();
      pre.decoding = 'async';
      pre.src = m.src;
    }
  });
})();

function efmRenderMedia(idx) {
  var wrap = document.getElementById('efmMainWrap');
  if (!wrap) return;
  var m = efmAllMedia[idx];

  /* Crossfade without artificial delay — browser swaps immediately. */
  wrap.style.transition = 'opacity 140ms ease';
  wrap.style.opacity = '0.35';

  var finish = function() { wrap.style.opacity = '1'; };

  /* Reuse existing elements instead of nuking innerHTML each time */
  var existingVideo = wrap.querySelector('video#efmMainVideo');
  var existingImage = wrap.querySelector('img#efmMainImage');
  var existingIframe = wrap.querySelector('iframe#efmMainIframe');

  if (m.type === 'video') {
    if (existingImage) existingImage.style.display = 'none';
    if (existingIframe) existingIframe.remove();

    if (!existingVideo) {
      var video = document.createElement('video');
      video.id = 'efmMainVideo';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.autoplay = true;
      video.preload = 'metadata';
      video.poster = m.poster || '';
      video.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;background:#F7F3EE;';
      m.sources.forEach(function(s) {
        var source = document.createElement('source');
        source.src = s.url;
        source.type = s.mime;
        video.appendChild(source);
      });
      wrap.appendChild(video);
      video.play().catch(function(){});
    } else {
      existingVideo.style.display = 'block';
      if (existingVideo.paused) existingVideo.play().catch(function(){});
    }
    finish();

  } else if (m.type === 'external_video') {
    if (existingVideo) existingVideo.style.display = 'none';
    if (existingImage) existingImage.style.display = 'none';

    if (!existingIframe || existingIframe.src !== m.url) {
      if (existingIframe) existingIframe.remove();
      var iframe = document.createElement('iframe');
      iframe.id = 'efmMainIframe';
      iframe.src = m.url;
      iframe.allow = 'autoplay; encrypted-media';
      iframe.allowFullscreen = true;
      iframe.style.cssText = 'width:100%;height:100%;border:none;display:block;position:absolute;top:0;left:0;';
      wrap.appendChild(iframe);
    }
    finish();

  } else {
    if (existingVideo) {
      existingVideo.style.display = 'none';
      if (!existingVideo.paused) existingVideo.pause();
    }
    if (existingIframe) existingIframe.remove();

    if (existingImage) {
      /* If <img> is wrapped in <picture>, the <source> element with srcset
         overrides <img src> on viewports matching its media query. On desktop
         â‰¥1025px the source loads the video preview frame, which makes <img src>
         changes invisible — gallery appears stuck on first frame.
         Remove any <source> elements on first navigation so subsequent src
         updates take visible effect. */
      var picParent = existingImage.parentElement;
      if (picParent && picParent.tagName === 'PICTURE') {
        picParent.querySelectorAll('source').forEach(function(s) { s.remove(); });
      }
      existingImage.style.display = 'block';
      if (existingImage.src !== m.src) {
        if (existingImage.decode) {
          existingImage.src = m.src;
          existingImage.decode().then(finish).catch(finish);
        } else {
          existingImage.onload = finish;
          existingImage.src = m.src;
        }
      } else {
        finish();
      }
    } else {
      var img = document.createElement('img');
      img.id = 'efmMainImage';
      img.src = m.src;
      img.alt = '';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
      wrap.appendChild(img);
      if (img.decode) img.decode().then(finish).catch(finish);
      else img.onload = finish;
    }
  }
}

window.efmNavImage = function(dir) {
  efmCurrentIdx = (efmCurrentIdx + dir + efmAllMedia.length) % efmAllMedia.length;
  efmRenderMedia(efmCurrentIdx);
  var counter = document.getElementById('efmCounter');
  if (counter) counter.textContent = (efmCurrentIdx + 1) + ' / ' + efmAllMedia.length;
  var thumbs = document.querySelectorAll('.ef-cfg-mantel-thumb');
  thumbs.forEach(function(t, i) {
    t.classList.toggle('is-active', i === efmCurrentIdx);
    if (i === efmCurrentIdx) t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  });
};

(function efmUpgradeToVideoOnDesktop() {
  if (window.innerWidth < 1025) return;

  var wrap = document.getElementById('efmMainWrap');
  if (!wrap) return;

  var videoIdx = parseInt(wrap.getAttribute('data-video-index'), 10);
  if (isNaN(videoIdx) || videoIdx < 0) return;

  var sourcesAttr = wrap.getAttribute('data-video-sources');
  if (!sourcesAttr) return;

  var sources;
  try { sources = JSON.parse(sourcesAttr); } catch (e) { return; }
  if (!sources || !sources.length) return;

  var trigger = function() {
    if (window.efmCurrentIdx !== 0) return;
    window.efmCurrentIdx = videoIdx;
    if (typeof efmRenderMedia === 'function') efmRenderMedia(videoIdx);

    var counter = document.getElementById('efmCounter');
    if (counter && window.efmAllMedia) {
      counter.textContent = (videoIdx + 1) + ' / ' + window.efmAllMedia.length;
    }
    document.querySelectorAll('.ef-cfg-mantel-thumb').forEach(function(t, i) {
      t.classList.toggle('is-active', i === videoIdx);
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(trigger, { timeout: 1500 });
  } else {
    setTimeout(trigger, 800);
  }
})();

/* â”€â”€ Touch swipe for mobile gallery â”€â”€ */
(function() {
  var gal = document.getElementById('efmGalleryMain');
  if (!gal) return;
  var startX = 0, startY = 0, tracking = false;
  gal.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    tracking = true;
  }, { passive: true });
  gal.addEventListener('touchend', function(e) {
    if (!tracking) return;
    tracking = false;
    var dx = e.changedTouches[0].clientX - startX;
    var dy = e.changedTouches[0].clientY - startY;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
      window.efmNavImage(dx < 0 ? 1 : -1);
    }
  }, { passive: true });
})();

/* â”€â”€ Accordion toggle (matches doors fix from 2026-04 — keeps the clicked
   trigger's viewport position stable when other accordions close above it).
   Without the position-correction below, opening a tab near the bottom of
   the list (e.g. "Shipping & Returns") jumps the page down because the
   sibling collapses change layout above the trigger. â”€â”€ */
window.efmAccToggle = function(trigger) {
  var item = trigger.closest('.ef-cfg-mantel-acc-item');
  var body = item.querySelector('.ef-cfg-mantel-acc-body');
  var isOpen = item.classList.contains('is-open');

  /* Closing the clicked tab — no anchor needed, just collapse */
  if (isOpen) {
    item.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    body.style.maxHeight = '0';
    return;
  }

  /* OPENING — capture trigger position BEFORE any layout change */
  var beforeTop = trigger.getBoundingClientRect().top;

  /* Close all other open items INSTANTLY (no transition) so layout contracts
     synchronously. Save+restore transition so future toggles still animate. */
  document.querySelectorAll('.ef-cfg-mantel-acc-item.is-open').forEach(function(other) {
    if (other === item) return;
    var otherBody = other.querySelector('.ef-cfg-mantel-acc-body');
    var prevTrans = otherBody.style.transition;
    otherBody.style.transition = 'none';
    otherBody.style.maxHeight = '0';
    other.classList.remove('is-open');
    other.querySelector('.ef-cfg-mantel-acc-trigger').setAttribute('aria-expanded', 'false');
    void otherBody.offsetHeight; /* force synchronous reflow */
    requestAnimationFrame(function () { otherBody.style.transition = prevTrans; });
  });

  /* Open the clicked item (animated) */
  item.classList.add('is-open');
  trigger.setAttribute('aria-expanded', 'true');
  body.style.maxHeight = body.scrollHeight + 'px';

  /* Layout has settled. Scroll the page to keep the trigger where the user
     clicked — eliminates the jump-to-bottom bug when opening tabs near the
     end of the accordion list. */
  var afterTop = trigger.getBoundingClientRect().top;
  var delta = afterTop - beforeTop;
  if (Math.abs(delta) > 1) {
    window.scrollBy(0, delta);
  }
};

/* â”€â”€ Sticky ATC bar click â”€â”€ */
(function() {
  var stickyBtn = document.getElementById('efmStickyBtn');
  var mainATC = document.getElementById('efmSubmit');
  if (stickyBtn && mainATC) {
    stickyBtn.addEventListener('click', function() { mainATC.click(); });
  }
})();
